import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { IPasswordChange } from '@app/modules/auth/interface/password-change';

@Component({
  selector: 'app-user-sidebar',
  templateUrl: './user-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSidebarComponent {
  @Input() loading$: Observable<boolean>;
  @Input() userSidebarVisible$: Observable<boolean>;
  @Output() changeUserSidebarVisibleEvent = new EventEmitter<boolean>();
  @Output() logoutEvent = new EventEmitter<void>();
  @Output() passwordChangeEvent = new EventEmitter<IPasswordChange>();
}
